import { useQuery, type QueryKey } from '@tanstack/react-query';
import service from '@Service';
import { REPORT_LIST_STALE_MS } from './useShiftReports';
import type {
  WeddingReportSummary,
  WeddingReportDetail,
} from '@Types/weddingReport';

export const weddingReportKeys = {
  forSoul: (soulId: string) => ['wedding-reports', 'soul', soulId] as const,
  detail: (id: string) => ['wedding-report', id] as const,
};

export function useWeddingReports({
  soulId,
  enabled = true,
  refetchInterval = false,
}: {
  soulId?: string;
  enabled?: boolean;
  refetchInterval?: number | false;
}) {
  return useQuery<WeddingReportSummary[]>({
    queryKey: weddingReportKeys.forSoul(soulId!) as unknown as QueryKey,
    queryFn: () => service.getWeddingReports({ soulId: soulId! }),
    enabled: enabled && !!soulId,
    refetchInterval,
    staleTime: REPORT_LIST_STALE_MS,
  });
}

export function useWeddingReport({
  id,
  enabled = true,
}: {
  id?: string;
  enabled?: boolean;
}) {
  return useQuery<WeddingReportDetail>({
    queryKey: weddingReportKeys.detail(id!) as unknown as QueryKey,
    queryFn: () => service.getWeddingReport(id!),
    enabled: enabled && !!id,
    // A persisted report never changes; reopening the sheet or refocusing the
    // window must not re-download its email HTML.
    staleTime: Infinity,
  });
}
